import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/house-icon-black.svg'


const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row align-items-center position-relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-badge" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Bolåneansökan")
  ])
], -1)
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "row mb-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Ansökt belopp:", -1)
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "row mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Bostadsvärde:", -1)
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "row mb-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Typ av bostad:", -1)
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = {
  key: 0,
  class: "card-content"
}
const _hoisted_17 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Kontantinsats:", -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "row mb-1" }
const _hoisted_21 = { class: "col-6 text-end" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "row mb-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Område:", -1)
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "row mb-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Status på din ansökan:", -1)
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "col-md-1" }
const _hoisted_30 = {
  key: 0,
  class: "btn btn-sm btn-outline"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-down",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "btn btn-sm btn-outline"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-up",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
  })
], -1)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "card-content",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.app.loanAmount)) + " kr", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.app.propertyValue)) + " kr", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.mapHousing(_ctx.app.propertyHousing)), 1)
                ])
              ])
            ]),
            (_ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.app.purpose != 'Renegotiate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.app.downPayment)) + " kr", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.app.propertyHousing == 'Condominium' ? 'Avgift till förening:' : 'Driftkostnad:'), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.app.propertyMonthlyCost)) + " kr", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.app.propertyCounty), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.getStatus()), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
              class: "card-btn"
            }, [
              (!_ctx.expanded)
                ? (_openBlock(), _createElementBlock("button", _hoisted_30, _hoisted_32))
                : (_openBlock(), _createElementBlock("button", _hoisted_33, _hoisted_35))
            ])
          ])
        ])
      ])
    ])
  ]))
}